module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Food/Cake-0bfde1e6ce596d919080e4cd5ad53526fb7c19b62b0b5110b37058e9a5959010.svg";